import { render, staticRenderFns } from "./ClientesView.vue?vue&type=template&id=40ff5dc8&"
import script from "./ClientesView.vue?vue&type=script&lang=js&"
export * from "./ClientesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports